/**************************************************************************************************************************************************
*   MODULE NAME     :  MetricsApi
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  14-04-2021
*   DESCRIPTION     :  Metrics API class
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import axios from "axios";
import ApiBase from "./ApiBase";
import config from "../config.json";

class MetricsApi {
    static async getOtherMetrics(metricsData) {
        let payload = { action: "getOtherMetrics", data: metricsData }
        return ApiBase.post(`${config.Backend_URL}/metric`, payload);
    }
    static async getAggregateMetrics(metricsData) {
        let payload = { action: "getAggregateMetrics", data: metricsData }
        return ApiBase.post(`${config.Backend_URL}/metric`, payload);
    }
    static async getOtherMetricsPagination(metricsData) {
        metricsData.action =  "getOtherMetricsPagination";
        return ApiBase.post(`${config.Backend_URL}/metric`, metricsData);
    }
}

export default MetricsApi;